export class LanguageConfig {
    url = './language/assets/languages.json';
}
